import React from 'react';
import logo from './assets/images/logo.png';
import mainImage from './assets/images/main_image.png';
import img1 from './assets/images/section2-img1.png';
import img2 from './assets/images/section2-img2.png';
import img3 from './assets/images/section2-img3.png';
import './App.css';

function App() {
  return (
    <div className="wedding-container">
      <nav className="wedding-navbar">
        <div style={{ flex: 1 }}></div>
        <a href="/">
          <img src={logo} alt="logo" className="wedding-logo" />
        </a>
        <div className="wedding-nav-links right">
          <a href="#gallery">GALLERY</a>
          <a href="#our-story">OUR STORY</a>
        </div>
      </nav>
      <section className="hero-section" style={{backgroundImage: `linear-gradient(rgba(0,0,0,0.7),rgba(0,0,0,0.7)), url(${mainImage})`}}>
        <div className="hero-content">
          <div className="hero-title-script">
            <div className="hero-hey">Hey!</div>
            <div className="hero-we-are-married">We are Married</div>
          </div>
        </div>
      </section>
      <section className="welcome-section">
        <p className="welcome-message" id="gallery">
          Welcome to our wedding website! We've created this site as a convenient and interactive way to share all the important details with you leading up to our wedding. We can't wait to celebrate this exciting new chapter of our lives together with you.
        </p>
        <div className="photo-grid">
          <img src={img1} alt="wedding1" />
          <img src={img2} alt="wedding2" />
          <img src={img3} alt="wedding3" />
        </div>
      </section>
      <section className="thankyou-section" style={{backgroundImage: `linear-gradient(rgba(0,0,0,0.7),rgba(0,0,0,0.7)), url(${img1})`}}>
        <div className="thankyou-content">
          <div className="thankyou-title">OUR HEARTS ARE FILLED</div>
          <div className="thankyou-script">Thank You for all the Love and Blessings</div>
        </div>
      </section>
      <section className="ourstory-section" id="our-story">
        <h2 className="ourstory-title">Our Story</h2>
        <p className="ourstory-text">
          Our love story began on a crisp summer evening in 2024 in Delhi, where we met for the first time. It was unexpected yet beautifully serendipitous. The journey of getting to know each other, understanding one another, and growing together felt nothing short of magical.<br/><br/>
          We dated, explored food (because we both love food!), and hopped from one café to another—all in a single day! Amidst the excitement and little adventures, what truly mattered was the time we spent together, growing closer with each passing moment.<br/>
          And then, we fell in love and said YES—to forever.
        </p>
        <img src={img2} alt="our story" className="ourstory-img" />
      </section>
      <footer className="footer-section">
        <div className="footer-script">Happily Ever After</div>
      </footer>
    </div>
  );
}

export default App;